import React, { useEffect, useMemo, useState } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import Cite from "citation-js";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import controllers from "../controllers/publications";
import LoaderData from "../component/LoaderData/LoaderData";
import { useTranslation } from "react-i18next";
import Pagination from "../elements/common/Pagination";
import moment from "moment";

const Project = () => {
  const [citeModal, setCiteModal] = useState(false);
  const [CiteData, setCiteData] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [opendetailsModal, setOpenDetailsModal] = useState(false);
  const [citeloading, setCiteLoading] = useState(false);

  //
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  const [data, setData] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 5;

  const getPublicationsList = (query) => {
    setLoading(true);
    return controllers
      .getPublicationsList(query)
      .then((response) => {
        setData(response.Publications);
        setTotalPages(Math.ceil(response.Total / itemsPerPage));
        setTimeout(() => {
          setLoading(false);
        }, 400);
      })
      .catch((error) => {
        setLoading(false);
        window.location.href = "/500";
      });
  };

  useEffect(() => {
    getPublicationsList({
      limit: itemsPerPage,
      page: currentPage - 1,
    });
  }, [currentPage]);

  if (loading) {
    return <LoaderData />;
  }

  const toggleCite = (citeDoi) => {
    try {
      if (citeDoi) {
        setCiteModal(true);
        setCiteLoading(true);
        setTimeout(() => {
          var newElement = [];
          const cite = new Cite();
          let example = cite.set(citeDoi);
          let array = ["apa", "bibtex"];
          array.forEach((item) => {
            let output = example.format("bibliography", {
              format: "text",
              template: item,
              lang: "en-US",
            });
            newElement.push({
              type: item,
              data: output,
            });
          });
          setCiteData(newElement);
          setCiteLoading(false);
        }, 500);
      }
    } catch (error) {
      alert("The publication Doi is not valid");
    }
  };
  const toggleDetailsmodal = (title, description) => {
    setOpenDetailsModal(true);
    setDetailsModal({
      title,
      description,
    });
  };

  const handleCloseCite = () => {
    setCiteModal(false);
    setTimeout(() => {
      setCiteData(false);
    }, 200);
  };
  const handleCloseDetailModal = () => {
    setOpenDetailsModal(false);
    setTimeout(() => {
      setDetailsModal(false);
    }, 500);
  };

  return (
    <>
      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />

      <Breadcrumb title={"Publications"} />

      <main id="publications" className="page-wrapper">
        <div className="project-area ptb--120 bg_color--5">
          <div className="project-sacousel-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center">
                    <span className="subtitle">Publications</span>
                    <h2 className="title">Publications List</h2>
                  </div>
                </div>
              </div>
              {(!data && !loading) ||
                (data.length === 0 && !loading && (
                  <h4
                    style={{
                      margin: "50px auto",
                      textAlign: "center",
                      color: "#c4c4c4",
                    }}
                  >
                    {isEnglish
                      ? "No publications found !"
                      : "Aucune publication trouvée !"}
                  </h4>
                ))}
              <div className="row">
                <div className="col-lg-12">
                  <div className="experience-list">
                    {data &&
                      data.length > 0 &&
                      data.map((publication, index) => (
                        <div key={index} className="resume-single-list">
                          <div className="inner">
                            <div className="heading">
                              <div className="title">
                                <h4>
                                  {publication.title.en && isEnglish
                                    ? publication.title.en
                                    : publication.title.fr}
                                </h4>
                                <span>
                                  <b>Authors : </b>
                                  {publication.authors}
                                </span>
                                <span>
                                  <b>Publication Date : </b>
                                  {moment(publication.date).format(
                                    "DD MMM,YYYY"
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="description">
                              <div>
                                {publication.link && (
                                  <a
                                    href={publication.link}
                                    target="_blank"
                                    className="pBtn ml-2"
                                  >
                                    Show More{" "}
                                    <i className="ti-angle-double-up"></i>
                                  </a>
                                )}

                                {publication.doi && (
                                  <a
                                    onClick={() => toggleCite(publication.doi)}
                                    className="pBtn ml-2"
                                  >
                                    Cite<i className="ti-arrow-right"></i>
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="col-lg-12 mt--20">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>

          <Modal
            style={{ display: "block" }}
            open={citeModal}
            onClose={handleCloseCite}
            center
          >
            <div>
              {citeloading ? (
                <div style={{ padding: "0 150px 0 100px", margin: "0 auto" }}>
                  Loading ...
                </div>
              ) : (
                <table>
                  <tbody>
                    {CiteData &&
                      CiteData.length > 0 &&
                      CiteData.map((item) => (
                        <tr
                          data-aos="zoom-in"
                          style={{ display: "grid" }}
                          className="pb-4"
                        >
                          <th
                            scope="row"
                            style={{ textTransform: "capitalize" }}
                            className="pr-4"
                          >
                            {item.type}
                          </th>
                          <td>
                            <div className="gs_citr">{item.data}</div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          </Modal>
        </div>
      </main>

      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>

      <Footer />
    </>
  );
};

export default Project;
